(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('rankAddon', rankAddon);

    function rankAddon() {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/components/addon/rank/rank-addon.html',
            controller: 'RankAddonController',
            controllerAs: 'vb',
            link: link
        };
        return directive;

        function link(scope, element, attrs) {
            scope.score = 5;
            scope.progress = 0;

            var bottom = scope.score * 8.5;
            var left = 27 * bottom / 60;
            var width = 100 - 30 * bottom / 60;
            angular.element('.dashed-line').animate({
                bottom: bottom + '%',
                left: left + 'px',
                width: width + '%'
            }, 2000);
        }
    }
})();
